import { Cdn, createCdn } from '@sparted/shared-library/cdn';

export const twicpics: Cdn = createCdn({
  type: 'twicpics',
  domain: 'https://sparted.twic.pics/',
  instanceMapper: (instanceId) => `prod/${instanceId}`,
});

export const { getCdnFromS3Url, getCdnUrl } = twicpics;
